import React, { useState, useEffect } from 'react';
import { Grid, Box, Typography } from '@mui/material';
import RemoveCircleRoundedIcon from '@mui/icons-material/RemoveCircleRounded';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import ReplayIcon from '@mui/icons-material/Replay';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import RoundButton from '../components/roundButton';
import MemberComponent from '../components/memberComponent';
import EditModalManifold from '../components/editModalManifold';
import MoveModal from '../components/moveModal';

import {
  configuratorService,
  batchUncommit,
  Commit,
  batchCommitProductMember
} from '../../services/configuratorService';
import {
  getCommitsFromRootMember,
  getMembersFromRootMember,
  getStepMembers
} from '../../services/tactonService';

import { SetCommitsName } from '../../services/facetInteractionService';

function StackedProductNav(props) {
  const {
    startData,
    lang,
    handleStartData,
    sessionDataItems,
    isLoading,
    handleOnChange,
    editedWorkStation,
    handleEditedWorkStation,
    handleDeleteSegmentEdited,
    handleSetCommits,
    commits
  } = props;
  const [selectedOption, setSelectedOption] = useState(0);
  const [currentEditingStation, setCurrentEditingStation] = useState();
  const [currentEditingStationDesc, setCurrentEditingStationDesc] = useState();
  const [currentPosition, setCurrentPosition] = useState();
  const [editData, setEditData] = useState([]);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [moveStationName, setMoveStationName] = useState();
  const [openMoveModal, setOpenMoveModal] = useState(false);

  useEffect(() => {
    if (currentEditingStation) {
      let members = currentWorkstationMembers(currentEditingStation);
      setEditData(members);
    }
  }, [startData]);

  const clearSelections = () => {
    handleOnChange('', 'resetall', '');
    setSelectedOption(0);
    handleEditedWorkStation('', '', true);
  };

  const onSystemValeOptionsClick = async () => {
    isLoading(true);
    setSelectedOption(0);
    let response = await configuratorService(
      createRequest({ Step: getSystemValveName() })
    );
    handleStartData(response ? response : startData);
    isLoading(false);
  };

  const onModuleStationClick = async () => {
    isLoading(true);
    setSelectedOption(1);
    let response = await configuratorService(
      createRequest({ Step: getSectionsName() })
    );
    handleStartData(response ? response : startData);
    isLoading(false);
  };

  //To get all available sections
  const moduleStations = () => {
    var allSection = startData?.infoGroup?.partNumberValues;
    return allSection;
  };

  const createRequest = (data, configState) => {
    let requestData = {
      divisionId: sessionDataItems?.manufacturingDivision,
      configState: configState ? configState : startData.configState,
      configModel: sessionDataItems?.configModel,
      ...data
    };
    return requestData;
  };

  const getSystemValveDescription = () => {
    var systemValve = startData?.tactonModel.steps.filter(x =>
      x.name.includes('step_valve')
    );
    return systemValve[0].description;
  };

  const getSectionsDescription = () => {
    var sections = startData?.tactonModel.steps.filter(x =>
      x.name.includes('sections')
    );
    return sections[0].description;
  };

  const getSystemValveName = () => {
    var systemValve = startData?.tactonModel.steps.filter(x =>
      x.name.includes('step_valve')
    );
    return systemValve[0].name;
  };

  const getSectionsName = () => {
    var sections = startData?.tactonModel.steps.filter(x =>
      x.name.includes('sections')
    );
    return sections[0].name;
  };
  const isModuleStationConfigured = () => {
    return false;
  };

  const hasInactiveWorkstations = () => {
    var step = currentStep().rootGroup.members.filter(
      x =>
        x.name.includes('ui_group_section') &&
        x.properties &&
        x.properties.hidden == 'yes'
    );
    return step.length > 0;
  };

  //to get current step
  const currentStep = () => {
    var steps = startData.tactonModel.steps.filter(x => x.current == true);
    return steps[0];
  };

  const hasWorkstationEdits = workstationName => {
    let isExist =
      editedWorkStation.filter(x => x.key == workstationName)[0]?.value ===
        true || workstationName.includes('inlet');
    return isExist;
  };

  const canDupManipulateWorkstations = () => {
    var step = startData?.infoGroup?.partNumberValues?.filter(
      x => x.name.includes('ui_group_section') && !x.properties
    );
    return step.length > 0 && step.length < 10;
  };

  const canManipulateWorkstations = () => {
    var step = startData?.infoGroup?.partNumberValues?.filter(
      x => x.name.includes('ui_group_section') && !x.properties
    );
    return step.length > 1;
  };

  //To get stations header name
  const stationHeader = desc => {
    var headerName = desc.split(' ');
    return headerName.slice(1, -1).join(' ');
  };

  const currentWorkstationMembers = workstationName => {
    var currentStationMembers = startData?.infoGroup?.partNumberValues?.filter(
      x => x.name.includes(workstationName)
    );
    if (currentStationMembers.length > 0)
      return currentStationMembers[0]?.members;
    else return [];
  };

  const commitedMembers = workstationName => {
    var rootMemberGroup = startData?.infoGroup?.partNumberValues.filter(x =>
      x.name.includes(workstationName)
    );
    var commits = getCommitsFromRootMember(rootMemberGroup[0]);
    return commits;
  };
  const setWorkstationEdited = (name, value) => {
    handleEditedWorkStation(name, value);
  };

  const allActiveSections = response => {
    return response?.infoGroup?.partNumberValues.filter(
      x => x.name.includes('ui_group_section') && !x.properties
    );
  };

  //commitStation "Adds" another section/station by selecting "Yes" on "Add Another Section" on the previous section. This selection simply shows the next section.
  const commitStation = async response => {
    var allWorkSection = allActiveSections(response);
    var maxPosition = allWorkSection.length - 1;
    var lastAvailableSection = allWorkSection[maxPosition].members.filter(x =>
      x.name.includes('add_another_section')
    );

    let res = await Commit(
      createRequest(
        {
          Step: getSectionsName(),
          key: lastAvailableSection[0].name,
          value: 'Yes'
        },
        response.configState
      )
    );
    return res ? res : response;
  };

  const duplicateLastSection = async (allActiveSection, response) => {
    //Add next section/station
    response = await commitStation(response);

    //Get the commits/selection from the previous section to apply to this newly added section.
    var lastCommits = commitedMembers(
      allActiveSection[allActiveSection.length - 1].name
    );

    response = await getCommitsForSectionAndBatchCommit(
      allActiveSection.length,
      lastCommits,
      response
    );
    return response;
  };

  const hideLastSection = async (stationIndex, response) => {
    let allSections = allActiveSections(response);
    var previousSection = allSections[stationIndex - 1]; //Get the previous section

    var addStationMember = previousSection.members.filter(x =>
      x.name.includes('add_another_section')
    ); // Get the "Add Another Section" member

    if (addStationMember.length > 0) {
      let res = await Commit(
        createRequest(
          {
            Step: getSectionsName(),
            key: addStationMember[0].name,
            value: 'No'
          },
          response.configState
        )
      );
      return res ? res : response;
    } else return response;
  };

  const getCommitsForSectionAndBatchCommit = async (
    sectionIndex,
    commits,
    response
  ) => {
    let allSections = allActiveSections(response);
    if (commits.length > 0) {
      //Get members of the specific section
      var allSectionMembers = getMembersFromRootMember(
        allSections[sectionIndex]
      );
      //Get commits from the members of the specific section.
      var commitingMembers = getCommitingMembers(allSectionMembers, commits);
      //commit the selection in batch.
      //
      if (commitingMembers.length > 0) {
        response = await batchCommit(
          commitingMembers,
          allSections[sectionIndex].name,
          response.configState
        );
      }
    }
    return response;
  };

  const getCommitingMembers = (allMembers, commitMembers) => {
    var commitingMemberArr = [];
    for (var j = 0; j < commitMembers.length; j++) {
      if (!commitMembers[j].name.includes('add_another_section')) {
        var data = allMembers.filter(
          x => x.description == commitMembers[j].description
        );
        var obj = {};
        obj['key'] = data[0].name;
        obj['value'] = commitMembers[j].value;
        commitingMemberArr.push(obj);
      }
    }
    return commitingMemberArr;
  };

  const batchCommit = async (commitMembers, sectionName, configState) => {
    console.log(sectionName);

    let res = await batchCommitProductMember(
      createRequest(
        { Step: getSectionsName(), commits: commitMembers },
        configState
      )
    );

    setWorkstationEdited(sectionName, true);
    return res;
  };

  const batchUnCommitStackNav = async (
    commitMembers,
    sectionName,
    response
  ) => {
    commitMembers = commitMembers.filter(
      x => !x.name.includes('add_another_section')
    );
    if (commitMembers.length > 0) {
      let res = await batchUncommit(
        createRequest(
          {
            Step: getSectionsName(),
            commits: commitMembers.map(x => x.name)
          },
          response.configState
        )
      );
      response = res ? res : response;

      handleDeleteSegmentEdited(sectionName);
    }
    return response;
  };

  const stationCount = () => {
    return allActiveSections(startData).length;
  };

  const onEditWorkstation = (
    workstationName,
    workstationDescription,
    position
  ) => {
    setCurrentEditingStation(workstationName);
    setCurrentEditingStationDesc(workstationDescription);
    setCurrentPosition(membersCount() + position);
    setEditData(currentWorkstationMembers(workstationName));
    setOpenEditModal(true);
  };

  const onAddStationClick = async () => {
    isLoading(true);
    handleStartData(await commitStation(startData));
    isLoading(false);
  };
  const onDuplicateWorkstationClick = async workstationName => {
    isLoading(true);
    let response = startData;
    var allActiveSection = allActiveSections(startData); //get all available work sections
    var startIndex = allActiveSection.findIndex(
      x => x.name === workstationName
    ); //get index of duplicating work section
    var previousCommits;
    var currentCommits;

    //When the user clicks on the last/bottom visible section on screen
    var IsthislastsectionOnScreen = allActiveSection.length == startIndex + 1;

    if (IsthislastsectionOnScreen) {
      response = await duplicateLastSection(allActiveSection, response);
    }

    for (var i = startIndex; i < allActiveSection.length; i++) {
      //This is the section that user has clicked "Duplicate" on screen.
      var IsthisSectiontoduplicate = i == startIndex;

      //During duplication, we would reach the last section on screen to duplicate.
      //In that case, we need to show/create a new section and then copy/duplicate the previous section commits.
      var IsItthelastSectionOnScreenToDuplicate =
        i == allActiveSection.length - 1;

      //When we duplicate a section in between the visible sections, then we store the commits/selections of that section in "previousCommits"
      //We will use these commits to duplicate the next section.
      if (IsthisSectiontoduplicate) {
        previousCommits = commitedMembers(allActiveSection[i].name);
        continue;
      }

      currentCommits = commitedMembers(allActiveSection[i].name);

      response = await batchUnCommitStackNav(
        currentCommits,
        allActiveSection[i].name,
        response
      );

      response = await getCommitsForSectionAndBatchCommit(
        i,
        previousCommits,
        response
      );

      previousCommits = currentCommits;

      if (IsItthelastSectionOnScreenToDuplicate) {
        //Create/show a new section
        response = await commitStation(response);

        //Duplicate/apply the current commits/selections to the newly created/showed section.
        response = await getCommitsForSectionAndBatchCommit(
          i + 1,
          currentCommits,
          response
        );
      }
    }
    handleStartData(response);
    isLoading(false);
  };
  const onDeleteWorkstationClick = async workstationName => {
    isLoading(true);
    let response = startData;
    var allActiveSection = allActiveSections(response); //get all available work sections
    var stationIndex = allActiveSection.findIndex(
      x => x.name === workstationName
    ); //get deleting section index

    var Isthislastsection = allActiveSection.length == stationIndex + 1;

    var deleteCommits = commitedMembers(workstationName); //Get the commits from the section to be deleted.

    response = await batchUnCommitStackNav(
      deleteCommits,
      workstationName,
      response
    ); //uncommit all the selections before deleting/hide

    //Check if this is the last section on screen to click. if yes, we don't have to loop through all the sections
    if (Isthislastsection) {
      response = await hideLastSection(stationIndex, response);
    } else {
      //If deleting the in-between section, then loop through the sections and rearrange them.

      // start from the next section, i.e., stationindex + 1, because we already took care of current section
      for (var i = stationIndex + 1; i < allActiveSection.length; i++) {
        //get the current commits before uncommit
        var currentCommits = commitedMembers(allActiveSection[i].name);
        //Uncommit the selections in this section.

        response = await batchUnCommitStackNav(
          currentCommits,
          allActiveSection[i].name,
          response
        );

        var checkagainforlastsection = allActiveSection.length == i + 1;
        //If this is the last section, then just hide it.
        if (checkagainforlastsection) {
          response = await hideLastSection(i, response);
        }
        //below if condition applies current selections, i.e., currentCommits, to the previous deleted section

        response = await getCommitsForSectionAndBatchCommit(
          i - 1,
          currentCommits,
          response
        );
      }
    }
    handleStartData(response);
    isLoading(false);
  };
  const onMoveWorkstationClick = workstationName => {
    setOpenMoveModal(true);
    setMoveStationName(workstationName);
  };

  const onWorkstationSave = () => {
    isLoading(true);
    setOpenEditModal(false);
    var editedMembers = commitedMembers(currentEditingStation);
    editedMembers = editedMembers.filter(
      x => !x.name.includes('add_another_section')
    );
    if (editedMembers.length > 0) {
      setWorkstationEdited(currentEditingStation, true);
      window['dataLayer'].push({
        event: 'facet_products',
        facet_category: currentEditingStationDesc,
        facet_category_pos: currentPosition,
        facet_sub_category: 'N/A',
        facet_sub_category_pos: 'N/A',
        product_category_name: sessionDataItems.breadCrumbText2
          ? sessionDataItems.breadCrumbText2
          : 'N/A',
        product_series_name: sessionDataItems.seriesName,
        product_series_id: sessionDataItems.productId
      });

      handleSetCommits(
        SetCommitsName(
          commits,
          currentEditingStationDesc,
          currentPosition,
          startData
        )
      );
    }
    isLoading(false);
  };
  const onWorkstationCancel = async () => {
    isLoading(true);
    var commits = commitedMembers(currentEditingStation);
    commits = commits.filter(x => !x.name.includes('add_another_section'));
    if (commits.length > 0) {
      let response = await batchUncommit(
        createRequest({
          commits: commits.map(x => x.name),
          Step: getSectionsName()
        })
      );
      handleStartData(response ? response : startData);
      handleDeleteSegmentEdited(currentEditingStation);
    }
    setOpenEditModal(false);
    isLoading(false);
  };

  const onMoveConfirm = async moveStationNumber => {
    isLoading(true);
    setOpenMoveModal(false);
    let response = startData;
    var activeStation = allActiveSections(response); //get all active worksections
    var nextCommits;
    var stationIndex = activeStation.findIndex(x => x.name === moveStationName); //get move section index
    var moveCommits = commitedMembers(moveStationName); //get moving committed members
    //condition to check if section index is greater than movestation number(Bottom to Top approach)
    if (stationIndex + 1 > moveStationNumber) {
      for (var i = moveStationNumber - 1; i < stationIndex + 1; i++) {
        var currentCommits;
        //condition to check if "i" eqal to move section number then assign the move commits to "currentCommits" variable
        if (i == moveStationNumber - 1) {
          currentCommits = moveCommits;
        } else {
          //if condition fails then assign "nextCommits"(committed members previour loop) to "currentCommits"
          currentCommits = nextCommits;
        }

        nextCommits = commitedMembers(activeStation[i].name); //get commited members of current loop by using section name
        response = await batchUnCommitStackNav(
          nextCommits,
          activeStation[i].name,
          response
        ); //Reset the current looping section by using section name

        var allSectionMembers = getMembersFromRootMember(activeStation[i]); //get all the members current looping section
        var commitingMembers = getCommitingMembers(
          allSectionMembers,
          currentCommits
        ); //get commiting members by using "allSectionMembers" and currentCommits
        if (commitingMembers.length > 0) {
          response = await batchCommit(
            commitingMembers,
            activeStation[i].name,
            response.configState
          ); //Commit the "commitingMembers" to current looping section
        }
      }
    } else if (stationIndex + 1 < moveStationNumber) {
      //condition to check if section index is less than movestation number(Top to Bottom approach)
      for (var i = stationIndex; i < moveStationNumber; i++) {
        var currentCommits;
        //condition to check if "i" eqal to move section number then assign the move commits to "currentCommits" variable
        if (i == moveStationNumber - 1) {
          currentCommits = moveCommits;
        } else {
          //if condition fails then assign "nextCommits"(committed members previour loop) to "currentCommits"
          currentCommits = commitedMembers(activeStation[i + 1].name);
        }

        nextCommits = commitedMembers(activeStation[i].name); //get commited members of current loop by using section name
        response = await batchUnCommitStackNav(
          nextCommits,
          activeStation[i].name,
          response
        ); //Reset the current looping section by using section name

        var allSectionMembers = getMembersFromRootMember(activeStation[i]); //get all the members current looping section
        var commitingMembers = getCommitingMembers(
          allSectionMembers,
          currentCommits
        ); //get commiting members by using "allSectionMembers" and currentCommits
        if (commitingMembers.length > 0) {
          response = await batchCommit(
            commitingMembers,
            activeStation[i].name,
            response.configState
          ); //Commit the "commitingMembers" to current looping section
        }
      }
    }
    handleStartData(response);
    isLoading(false);
  };

  const onMoveCancel = () => {
    setOpenMoveModal(false);
  };

  const membersCount = () => {
    return getStepMembers(startData)?.length;
  };
  return (
    <>
      {openEditModal && (
        <EditModalManifold
          open={openEditModal}
          handleClose={onWorkstationSave}
          handleCancel={onWorkstationCancel}
          handleOnChange={handleOnChange}
          data={editData}
          lang={lang}
          startData={startData}
          sessionDataItems={sessionDataItems}
        />
      )}

      {openMoveModal && (
        <MoveModal
          open={openMoveModal}
          onValChange={e => onMoveConfirm(e)}
          handleClose={() => onMoveCancel(false)}
          lang={lang}
          max={stationCount()}
        />
      )}

      <Grid container>
        <Grid className="dynamic-stack-option">
          <Box
            className="headBoxLeft"
            sx={
              selectedOption == 0
                ? {
                    border: '1px solid #ffb91d',
                    borderBottom: '4px solid #ffb91d'
                  }
                : {}
            }
            onClick={() => onSystemValeOptionsClick()}
          >
            <Typography className="headText">
              {getSystemValveDescription()}
            </Typography>
          </Box>
          <Box
            className="headBoxLeft"
            sx={
              selectedOption == 1
                ? {
                    border: '1px solid #ffb91d',
                    borderBottom: '4px solid #ffb91d'
                  }
                : {}
            }
            onClick={() => onModuleStationClick()}
          >
            <Typography className="headText">
              {getSectionsDescription()}
            </Typography>
            {isModuleStationConfigured() ? (
              <CheckCircleRoundedIcon className="green-check-segment" />
            ) : (
              <RemoveCircleRoundedIcon className="remove-circle-segment" />
            )}
          </Box>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={selectedOption == 0 ? 12 : 6}
          lg={selectedOption == 0 ? 12 : 6}
        >
          <a className="clear-selections" onClick={() => clearSelections()}>
            <ReplayIcon className="replay-icon-clear" />
            {lang.RESET_SELECTIONS_TO_BASE_MODEL}
          </a>
        </Grid>
        {selectedOption == 1 && (
          <Grid
            item
            xs={12}
            sm={12}
            md={selectedOption == 0 ? 12 : 6}
            lg={selectedOption == 0 ? 12 : 6}
            className="align-center"
          >
            {hasInactiveWorkstations() && (
              <RoundButton
                name={
                  <>
                    <AddRoundedIcon className="add-rounded-icon" />
                    {props.lang?.ADD_STATION}
                  </>
                }
                classname="add-station"
                onClick={() => onAddStationClick()}
              />
            )}
          </Grid>
        )}

        {selectedOption == 0 && (
          <div className="options-content">
            {startData?.uiGroup?.members?.map((member, index) => {
              return (
                <div key={member.name + '_' + index}>
                  <MemberComponent
                    member={member}
                    startData={startData}
                    handleOnChange={handleOnChange}
                    sessionDataItems={sessionDataItems}
                    howGroupHeader={true}
                    lang={lang}
                  />
                </div>
              );
            })}
          </div>
        )}

        {selectedOption == 1 && (
          <div className="options-content">
            {moduleStations().map((workstation, index) => {
              return (
                <Grid key={workstation.name} className="work-section">
                  <Typography className="headText">
                    {stationHeader(workstation.description)}
                    {hasWorkstationEdits(workstation.name) ? (
                      <CheckCircleRoundedIcon className="green-check" />
                    ) : (
                      <RemoveCircleRoundedIcon className="remove-circle" />
                    )}
                  </Typography>
                  <div className="work-section-part">
                    {lang?.PART_NUMBER} : {workstation.value}
                  </div>
                  <div className="work-section-buttons">
                    <RoundButton
                      name={lang?.EDIT}
                      classname="edit-station"
                      onClick={() =>
                        onEditWorkstation(
                          workstation.name,
                          workstation.description,
                          index
                        )
                      }
                    />
                    {canDupManipulateWorkstations() &&
                      workstation.name.includes('section') && (
                        <RoundButton
                          name={lang?.DUPLICATE}
                          classname="edit-station"
                          onClick={() =>
                            onDuplicateWorkstationClick(workstation.name)
                          }
                        />
                      )}
                    {canManipulateWorkstations() &&
                      workstation.name.includes('section') && (
                        <RoundButton
                          name={lang?.DELETE}
                          classname="edit-station"
                          onClick={() =>
                            onDeleteWorkstationClick(workstation.name)
                          }
                        />
                      )}
                    {canManipulateWorkstations() &&
                      workstation.name.includes('section') && (
                        <RoundButton
                          name={lang?.MOVE}
                          classname="edit-station"
                          onClick={() =>
                            onMoveWorkstationClick(workstation.name)
                          }
                        />
                      )}
                  </div>
                </Grid>
              );
            })}
          </div>
        )}
      </Grid>
    </>
  );
}
export default StackedProductNav;
